import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(VTextField, {
        directives: [
          {
            name: "mask",
            rawName: "v-mask",
            value: _setup.maskOptions,
            expression: "maskOptions",
          },
        ],
        attrs: {
          value: _setup.ageInput,
          autofocus: _vm.autofocus,
          label: _setup.t("Возраст пациента", _setup.options),
          "clear-icon": "ui-icon-close-not-a-circle",
          "hide-details": "",
          clearable: "",
          outlined: "",
          type: "tel",
          maxlength: "3",
          inputmode: "numeric",
        },
        on: { input: _setup.handleInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }